import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  openDrawer() {
    const reload = this.element.dataset.reloadPageOnDrawerClose === "true"
    const event = new CustomEvent("drawer:open", {
      bubbles: true,
      detail: { url: this.element.dataset.urlValue, reload: reload }
    })
    document.dispatchEvent(event)
  }
}
